module.exports = __webpack_public_path__ + "img/reduceCost.86d5b67.svg";